"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_Revenge_OnAttackEventHandlerScript = void 0;
const __1 = require("../..");
const Damage_1 = require("../../core/Damage");
const Duration_1 = require("../../core/Duration");
const AttributeType_1 = require("../../core/enums/AttributeType");
const DamageType_1 = require("../../core/enums/DamageType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Ability_Revenge_OnAttackEventHandlerScript = class Ability_Revenge_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        else if (!event.args.hit) {
            return;
        }
        container.applyBuff({
            sequence,
            creatorId: event.subject,
            targetId: event.args.targetId,
            effect: new __1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.RevengeStacks, 1),
            duration: Duration_1.Duration.Turns(5),
        });
        const revengeStacks = container.getAttributeScore(event.args.targetId, AttributeType_1.AttributeType.RevengeStacks);
        const damage = handler.args.scriptArgs.baseDamage * revengeStacks;
        container.applyExactDamage({
            sequence,
            attackerId: event.subject,
            targetId: event.args.targetId,
            damage: new Damage_1.Damage(DamageType_1.DamageType.Holy, damage)
        });
    }
};
Ability_Revenge_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_Revenge_OnAttack")
], Ability_Revenge_OnAttackEventHandlerScript);
exports.Ability_Revenge_OnAttackEventHandlerScript = Ability_Revenge_OnAttackEventHandlerScript;
